export const CovenantPosition = [
    {
        "title": "Current Ratio",
        "criteria" : "≥ 100 %",
        "jan": "122.17",
        "feb": "0",
        "mar" : "0",
        "apr": "0",
        "may": "0",
        "jun": "0",
        "jul": "0",
        "aug": "0",
        "sep": "0",
        "oct": "0",
        "nov": "0",
        "dec": "0",
    },
    {
        "title": "Debt / Equity",
        "criteria" : "≤ 300 %",
        "jan": "4",
        "feb": "0",
        "mar" : "0",
        "apr": "0",
        "may": "0",
        "jun": "0",
        "jul": "0",
        "aug": "0",
        "sep": "0",
        "oct": "0",
        "nov": "0",
        "dec": "0",
    },{
        "title": "Debt Service Coverage Ratio",
        "criteria" : "≥ 100 %",
        "jan": "2688.27",
        "feb": "0",
        "mar" : "0",
        "apr": "0",
        "may": "0",
        "jun": "0",
        "jul": "0",
        "aug": "0",
        "sep": "0",
        "oct": "0",
        "nov": "0",
        "dec": "0",
    },
]